import { TitleButtonDivider } from '@/common/buttons/TitleButtonDivider';
import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { useFilterButtons } from '@/common/entityFramework/entityPerspective/hooks/useFilterButtons';
import { RowIcon } from '@/common/entityFramework/entityPerspective/support/RowIcon';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useRef } from 'react';

export const AbvPbmPymtPerspective = () => {

  const entityPerspectiveRef = useRef();

  const views = [
    {
      name: 'Payments',
      dims: ['PAID_PERIOD', 'CHANNEL', 'PBM', 'PROD', 'EARNED_PERIOD'],
      kpis: ['PYMT_AMT', 'PYMT_ADJ', 'TOTAL_PYMT'],
      dimToPeriodicities: {
        PAID_PERIOD: ['LIFETIME', 'YEAR', 'QTR', 'MON'],
        EARNED_PERIOD: ['YEAR', 'QTR']
      }
    }
  ];

  const { filterButtonStages, filterButtons, onViewReset } = useFilterButtons([
    {
      key: 'uncategorized',
      icon: fas.faExclamationTriangle,
      colors: [null, 'red', 'green'],
      toolTips: ['Uncategorized and categorized payments', 'Uncategorized payments', 'Categorized payments']
    }
  ]);

  const handleViewReset = useCallback(() => {
    onViewReset();
  }, [onViewReset]);

  const augButtons = (buttons) => {
    buttons.unshift(
      ...filterButtons, <TitleButtonDivider key="filterButtonDivider" />);
  }

  const augReqParam = useCallback((reqParam) => {
    // Uncategorized
    const uncategorizedButtonStage = filterButtonStages.uncategorized;
    if (uncategorizedButtonStage > 0) {
      reqParam.expr = ExprUtils.and(
        reqParam.expr,
        uncategorizedButtonStage === 1 ? ExprUtils.whereParams('uncategorized', 1) : ExprUtils.isNot('uncategorized', 1)
      )
    }
  }, [filterButtonStages]);

  const rowIconFn = (data) => {
    let rowIcons = [];

    // Uncategorized row icon
    if (data.uncategorized === 1) {
      rowIcons.push(<RowIcon key="uncategorized" icon={fas.faExclamationTriangle} color="red" toolTip="Uncategorized Payment" />);
    } else if (data.uncategorized > 0) {
      rowIcons.push(<RowIcon key="conatinsUncategorized" icon={fas.faExclamationTriangle} color="pink" toolTip="Conatins an uncategorized payment" />);
    }

    return rowIcons;
  }

  const getContextMenuItems = (params) => {
    let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

    contextMenus.push(
      {
        name: 'Payment Amounts',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'PYMT_AMT', 'Payment Amounts', 'PBM_PYMT_VIEWER_PLUGIN'),
        icon: fas.faListUl
      }, {
        name: 'Payment Adjustments',
        action: () => entityPerspectiveRef.current.navigateToViewer(params, 'PYMT_ADJ', 'Payment Adjustments'),
        icon: fas.faListUl
      }, {
        name: 'Export',
        action: () => entityPerspectiveRef.current.openExportDialog(params),
        icon: fas.faArrowCircleDown
      }
    );

    return contextMenus;
  }

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      views={views}
      rowIconsFn={rowIconFn}
      augButtons={augButtons}
      augReqParam={augReqParam}
      onViewReset={handleViewReset}
      gridOptions={{
        getContextMenuItems
      }}
    />
  )
}